/*global _ */
import { factory as settingFactory } from 'utils/vue/lib/settings'
import { createCustomTranslations } from 'utils/vue/lib/lang'

const DEFAULTS = {
  termsItems: { termsAgreed: 'no' },
  fieldGroups: {
    terms: {
      isMultiple: false,
      fieldNames: ["termsAgreed"],
      fields: {
        termsAgreed: {
          message: 'I HAVE READ & AGREE WITH ALL SUPERCHARGED TERMS & CONDITIONS'
        }
      }
    },
    // this part is for documentation
    participants: {
      infoTopHint: '',
      infoBottomHint: ''
    }
  }
}

export default {
  data() {
    return {
      termsItems: {},
      formFieldDetails: null,
      $$ps: () => '',
      $$pt: () => '',
      $$ptc: () => '',
      $$pd: () => '',
      $$pn: () => '',
    }
  },
  watch: {
    currentProduct: {
      handler(value, oldValue) {
        this.initProductSettingsTranslations(value, oldValue)
      },
      immediate: true
    },
    termsItems: {
      handler(value) {
        _.forOwn(value, (value, key) => {
          if (key !== 'termsAgreed') {
            this.setInput({ [key]: value })
          }
        })
        this.termsAgreed = _.every(value, agree => agree !== 'no') ? 'yes' : 'no'
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    initProductSettingsTranslations(product, oldValue) {
      if (product?.id !== oldValue?.id) {
        const settings = product?.custom?.settings_key
        this.$$ps = settingFactory(settings || false, false)
        const messages = product?.custom?.translations_key
        const i18n = createCustomTranslations(messages || false, false, false)
        this.$$pt = i18n.$$t
        this.$$ptc = i18n.$$tc
        this.$$pd = i18n.$$d
        this.$$pn = i18n.$$n
        this.initProductFieldGroups()
      }
    },
    initProductFieldGroups() {
      const defaultFieldGroups = _.cloneDeep(DEFAULTS.fieldGroups)
      this.termsItems = _.cloneDeep(DEFAULTS.termsItems)
      this.formFieldDetails = { groups: defaultFieldGroups }

      const fieldGroupDefs = this.$$ps && _.merge({}, this.$$pt('form.fieldGroups'), this.$$ps('form.fieldGroups'))
      if (_.isEmpty(fieldGroupDefs)) {
        return
      }

      // terms
      const def = fieldGroupDefs?.terms
      const hideTitle = def?.hideTitle || false
      const fieldNames = def?.fieldNames || defaultFieldGroups.terms.fieldNames
      const firstField = fieldNames[0]
      const isMultiple = (fieldNames?.length || 1) > 1
      const firstAsTitle = def?.firstLabelAsTitle || false

      const fields = fieldNames.reduce((all, name) => {
        all[name] = _.merge(
          {},
          defaultFieldGroups.terms.fields[name],
          this.$$pt('form.fields.' + name, {}),
          this.$$ps('form.fields.' + name, {})
        )
        return all
      }, {})

      const title = hideTitle ? false :
        (firstAsTitle ? fields[firstField].message : (def?.title || false))

      if (firstAsTitle) {
        fields[firstField].message = false
      }

      const terms = { title, fields, fieldNames, isMultiple }

      const groups = _.merge({}, _.omit(fieldGroupDefs, 'terms'), { terms })

      const groupOrder = this.$$ps('form.fieldGroupOrder', null)

      this.formFieldDetails = { groups, groupOrder }


      // term fields tracker
      const termFields = this.formFieldDetails?.groups?.terms?.fields || { termsAgreed: {} }
      Object.keys(this.termsItems).forEach((key) => {
        if (!(key in fields)) {
          this.$delete(this.termsItems, key)
        }
      })
      Object.keys(termFields).forEach((key) => {
        if (!(key in this.termsItems)) {
          this.$set(this.termsItems, key, 'no')
        }
      })
    },
  },
}
